import { FormDocument } from '@/features/ui/DocumentsData/model/types';

import { addDocumentAttachments, AttachmentPayload, toArray } from '@/shared/lib/helpers/payloadHelpers';

import { getERZDocumentTypeEntites } from '@/modules/erz/helpers';

import { ServiceFileManager } from '@/helpers/serviceFileManager';

import { DocumentTypeCode, FormDataType } from '@/api/types';

export const collectAttachments = (formData: FormDataType): AttachmentPayload[] => {
  const attachments: AttachmentPayload[] = [];

  if ((formData.missingPerson as any).document_additional_photos) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(
        (formData.missingPerson as any).document_additional_photos as Nullable<FormDocument | FormDocument[]>,
      ),
      'missingPerson.document_additional_photos',
    );
  }

  if ((formData.missingPerson as any).document_photo) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>((formData.missingPerson as any).document_photo as Nullable<FormDocument | FormDocument[]>),
      'missingPerson.document_photo',
    );
  }

  if ((formData.missingPerson as any).document_proofs_of_missings) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(
        (formData.missingPerson as any).document_proofs_of_missings as Nullable<FormDocument | FormDocument[]>,
      ),
      'missingPerson.document_proofs_of_missings',
    );
  }

  if ((formData.erdr as any).document_scanned_extract) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>((formData.erdr as any).document_scanned_extract as Nullable<FormDocument | FormDocument[]>),
      'erdr.document_scanned_extract',
    );
  }

  if ((formData.applicantData as any).documents_proofs_of_ancestral_connection) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(
        (formData.applicantData as any).documents_proofs_of_ancestral_connection as Nullable<
          FormDocument | FormDocument[]
        >,
      ),
      'applicantData.documents_proofs_of_ancestral_connection',
    );
  }

  return attachments;
};

export const generateApplicationAttachment = async (
  serviceFileManager?: ServiceFileManager | null,
): Promise<AttachmentPayload | null> => {
  const applicationFileId = serviceFileManager?.getAttachment()?.fileId ?? undefined;
  if (!applicationFileId) {
    return null;
  }

  const [pdfDocumentType] = await getERZDocumentTypeEntites([DocumentTypeCode.MISSING_PERSON]);
  const pdfCode = pdfDocumentType?.code && pdfDocumentType.code !== 'null' ? pdfDocumentType.code : pdfDocumentType?.id;
  const pdfLabel = pdfDocumentType?.label ?? pdfDocumentType?.id ?? 'application';
  const pdfId = pdfDocumentType?.id ?? pdfCode ?? pdfLabel;

  if (pdfDocumentType && pdfId && pdfCode && pdfLabel) {
    return {
      id: pdfId,
      typeDoc: pdfLabel,
      fileName: pdfLabel,
      code: pdfCode,
      info: {},
      formField: 'application',
      files: [applicationFileId],
    };
  }

  return null;
};
